import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Form,
  Input,
  Radio,
  Typography,
  Space,
  notification,
  Modal,
} from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import jsonSpanish from "../../../lang/es/globalRegionalCapituloV.json";
import jsonEnglish from "../../../lang/en/globalRegionalChapterV.json";

import { get, patch } from "../../../api/modules/globalRegionalAnswers";

import LoadingModal from "../../../components/LoadingModal";

import INTERNAL_LINKS from "../../../enum/InternalLinks";
import FORM_MESSAGES from "../../../enum/FormMessages";

const { Title } = Typography;
const { confirm } = Modal;

const GlobalRegionalPollChapterV = ({ history, match }) => {
  const [form] = Form.useForm();
  const [lang] = useState(match.params.lang);
  const [fileLang, setFileLang] = useState(jsonEnglish);
  const [loading, setLoading] = useState(false);
  const [statusForm, setStatusForm] = useState(0);
  const [q8b, setQ8b] = useState(false);
  const [requiredItems, setRequiredItems] = useState(false);
  const [answer, setAnswer] = useState({});

  useEffect(() => {
    getAnswer();
    if (lang === "en") {
      setFileLang(jsonEnglish);
    } else if (lang === "es") {
      setFileLang(jsonSpanish);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleQ8 = (value) => {
    value = parseInt(value);

    if (value === 1) {
      setQ8b(true);
    } else {
      setQ8b(false);
    }
  };

  const getAnswer = async () => {
    let response = await get(match.params.id);
    setAnswer(response.data);
    form.setFieldsValue(response.data);

    handleQ8(response.data.q8);
  };

  const save = async (data) => {
    setLoading(true);
    try {
      data["status_v"] = statusForm;
      await patch(match.params.id, data);
      notification.open({
        message: "Successful transaction / Transacción exitosa ",
        duration: 2,
        placement: "bottomRight",
      });
      history.push(`${INTERNAL_LINKS.GLOBAL_REGIONAL_POLL_HOME}/${match.params.id}`);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const confirmClose = async (status) => {
    confirm({
      title:
        lang === "en"
          ? "Are you sure you want to CLOSE the chapter? If you do so, you will not be able to edit information later."
          : "¿Está seguro de CERRAR el capítulo? Si lo hace no podrá editar información posteriormente.",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        setStatusForm(status);
        if (status === 1) {
          setRequiredItems(false);
        } else if (status === 2) {
          setRequiredItems(true);
        }
        form.submit();
      },
      onCancel() {
        setStatusForm(0);
        setRequiredItems(false);
        form.submit();
      },
    });
  };

  return (
    <div>
      {lang === "en" ? (
        <Title level={3}>
          PART V: DEVELOPMENT OF PUBLIC POLICIES AND GOOD PRACTICES
        </Title>
      ) : (
        <Title level={3}>
          PARTE V: DESARROLLO DE POLÍTICAS PÚBLICAS Y BUENAS PRÁCTICAS
        </Title>
      )}
      <Form
        form={form}
        layout="vertical"
        onFinish={(data) => {
          save(data);
        }}
        validateMessages={
          FORM_MESSAGES[`validateMessages${lang.toUpperCase()}`]
        }
        scrollToFirstError={true}
      >
        <Form.Item
          label={`7. ${fileLang.q7.text}`}
          name="q7"
          rules={[{ required: requiredItems }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`8. ${fileLang.q8.a.text}`}
          onChange={(event) => {
            handleQ8(event.target.value);
          }}
          name="q8_a"
          rules={[{ required: requiredItems }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={`8. ${fileLang.q8.b.text}`}
          onChange={(event) => {
            handleQ8(event.target.value);
          }}
          name="q8_b"
          rules={[{ required: requiredItems }]}
        >
          <Radio.Group>
            {fileLang.q8.b.options.map((item) => {
              return (
                <Radio key={`radio-q8-key-${item.value}`} value={item.value}>
                  {item.text}
                </Radio>
              );
            })}
          </Radio.Group>
        </Form.Item>
        {q8b === 1 && (
          <Form.Item
            label={`${fileLang.q8.b.explainText}`}
            name="q8_which"
            rules={[{ required: requiredItems }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
        )}
        <Form.Item
          label={`9. ${fileLang.q9.text}`}
          name="q9"
          rules={[{ required: requiredItems }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label={lang === "en" ? "Observations" : "Observaciones"}
          name="comments_v"
        >
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Space>
            {answer.status_v < 2 && (
              <>
                <Button
                  loading={loading}
                  type="primary"
                  onClick={() => {
                    setStatusForm(0);
                    setRequiredItems(false);
                  }}
                  htmlType="submit"
                >
                  {lang === "en" ? "Save (pending)" : "Guardar (parcial)"}
                </Button>
                <Button
                  loading={loading}
                  type="primary"
                  onClick={() => {
                    confirmClose(1);
                  }}
                >
                  {lang === "en" ? "Close (unfinished)" : "Cerrar (Parcial)"}
                </Button>
                <Button
                  loading={loading}
                  type="primary"
                  onClick={() => {
                    confirmClose(2);
                  }}
                >
                  {lang === "en" ? "Close" : "Cerrar"}
                </Button>
              </>
            )}
            <Button type="link">
              <Link
                to={`${INTERNAL_LINKS.GLOBAL_REGIONAL_POLL_HOME}/${match.params.id}`}
              >
                {lang === "en" ? "Back" : "Volver"}
              </Link>
            </Button>
          </Space>
        </Form.Item>
      </Form>
      <LoadingModal loading={loading} lang={lang}></LoadingModal>
    </div>
  );
};

export default GlobalRegionalPollChapterV;
